"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _pill = _interopRequireDefault(require("britive-design-system/core/components/pill"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _tooltip = _interopRequireDefault(require("britive-design-system/core/components/tooltip"));

var _modalPopup = _interopRequireDefault(require("britive-design-system/core/components/modal-popup"));

var _plusBlue = _interopRequireDefault(require("static/images/plus-blue.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

(function () {
  var styles = ".pill-list-table-column-wrapper {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  border-right: none;\n  margin: 10px 0px;\n  align-items: center;\n  position: relative;\n  height: 50px; }\n\n.pill-list-table-column-show-more {\n  cursor: pointer;\n  display: flex;\n  color: #0A63A8;\n  align-items: center; }\n  .pill-list-table-column-show-more > img {\n    height: 15px; }\n\n.pill-list-table-column-modal-wrapper {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap; }\n";
  var fileName = "compone_index";
  var element = document.querySelector("style[data-sass-component='compone_index']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

var CSS_CLASSNAME_PREFIX = 'pill-list-table-column';

var PillListTableColumn = function PillListTableColumn(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? 300 : _ref$maxWidth,
      onViewAllClick = _ref.onViewAllClick,
      _ref$tooltipMsg = _ref.tooltipMsg,
      tooltipMsg = _ref$tooltipMsg === void 0 ? 'View all' : _ref$tooltipMsg,
      _ref$modalTitle = _ref.modalTitle,
      modalTitle = _ref$modalTitle === void 0 ? 'View All' : _ref$modalTitle;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      pillWidths = _useState2[0],
      setPillWidths = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showMore = _useState4[0],
      setShowMore = _useState4[1];

  var uniqueIdPrefix = "".concat(data.join('-'), "-").concat(new Date().toISOString());
  (0, _react.useEffect)(function () {
    if ((0, _isEmpty.default)(data)) {
      setPillWidths([]);
      return;
    } // Temporary rendering the tags and saving the width of each in local state.


    var widthPromises = data.map(function (pill, index) {
      return new Promise(function (resolve) {
        var containerId = "pill-list-temporary-container-".concat(uniqueIdPrefix, "-").concat(index, "-").concat(pill);
        var temporaryContainer = document.createElement('div');
        temporaryContainer.setAttribute('id', containerId); // Added styles to hide the DOM from the view

        temporaryContainer.style.visibility = 'hidden';
        temporaryContainer.style.position = 'absolute';
        temporaryContainer.style.width = 'auto';
        temporaryContainer.style.whiteSpace = 'nowrap';
        document.body.appendChild(temporaryContainer);

        _reactDom.default.render( /*#__PURE__*/_react.default.createElement(_pill.default, {
          key: "".concat(uniqueIdPrefix, "-").concat(index, "-").concat(pill, "-temporary"),
          disabled: true,
          readOnly: true,
          label: pill
        }), document.getElementById(containerId));

        setTimeout(function () {
          var width = temporaryContainer.offsetWidth;

          _reactDom.default.unmountComponentAtNode(document.getElementById(containerId));

          resolve({
            pillName: pill,
            width: width
          });
        }, 0);
      });
    }); // Waiting for all width measurements to complete

    Promise.all(widthPromises).then(function (results) {
      setPillWidths(results);
    });
  }, [JSON.stringify(data)]);

  var closeModal = function closeModal() {
    setShowMore(false);
  };

  var handleViewAll = function handleViewAll() {
    if (typeof onViewAllClick === 'function') {
      onViewAllClick();
      return;
    }

    setShowMore(true);
  }; // Not using the local state to prevent rerender, and prevent batch updates


  var currentWidth = 0;
  var renderedPills = 0;
  /**
   * 1. Render the pills if it is below the max width.
   * 2. If atleast one pill was rendered, show the remaining count as a view more button.
   * 3. If no pill was rendered due to width issues, show "View All" as a clickable item.
   */

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-wrapper")
  }, pillWidths.map(function (pill, index) {
    currentWidth += pill.width;

    if (currentWidth < maxWidth) {
      renderedPills += 1;
      return /*#__PURE__*/_react.default.createElement(_pill.default, {
        key: "".concat(uniqueIdPrefix, "-").concat(index, "-").concat(pill),
        disabled: true,
        readOnly: true,
        label: pill.pillName
      });
    }
  }), currentWidth > maxWidth && renderedPills !== 0 && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: tooltipMsg,
    position: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-show-more"),
    onClick: handleViewAll
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _plusBlue.default
  }), /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, data.length - renderedPills))), !(0, _isEmpty.default)(data) && renderedPills === 0 && /*#__PURE__*/_react.default.createElement(_tooltip.default, {
    title: tooltipMsg,
    position: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-show-more"),
    onClick: handleViewAll
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, "View All"))), showMore && /*#__PURE__*/_react.default.createElement(_modalPopup.default, {
    width: 600,
    title: modalTitle,
    buttons: [{
      text: 'Close',
      variant: 'secondary',
      size: 'large',
      onClick: closeModal
    }],
    onCancel: closeModal
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(CSS_CLASSNAME_PREFIX, "-modal-wrapper")
  }, data.map(function (pill, index) {
    return /*#__PURE__*/_react.default.createElement(_pill.default, {
      key: "".concat(uniqueIdPrefix, "-").concat(index, "-").concat(pill, "-view-all-modal"),
      disabled: true,
      readOnly: true,
      label: pill
    });
  }))));
};

PillListTableColumn.propTypes = {
  data: _propTypes.default.array,
  maxWidth: _propTypes.default.number,
  onViewAllClick: _propTypes.default.func,
  // Optional. If this is passed, the modal in this component will not be rendered.
  tooltipMsg: _propTypes.default.string,
  modalTitle: _propTypes.default.string
};
var _default = PillListTableColumn;
exports.default = _default;